<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header *ngIf="!firstview"></app-header>
    <div class="site-content-wrap position-relative">
        <section class="db-fullvodeo-outer show" *ngIf="firstview">
            <div class="db-fullvodeo-inner">
                <div class="db-fullvodeo-video">
                    <video [src]="detaildata.welcome_video" class="cus_file_overlay w-100" controls disablePictureInPicture controlsList="noplaybackrate nodownload" autoplay type="video/*" id="myAudio"></video>
                </div>
            </div>
            <a class="video-skip-btn" href="javascript:void(0);" (click)="skip()" type="button"><span [translate]="'GREATER.SKIP'"> </span>  </a>
        </section>

        <app-sidebar *ngIf="!firstview"></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper" *ngIf="!firstview">
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb pb-3">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="breadcrumb-title m-0 pe-3"><span [translate]="'GREATER.DASHBOARD'"> </span></h3>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <section class="inner-section-wrap">
                    <div class="row justify-content-center justify-content-lg-start">
                        <div class="col-12 col-lg-7 pb-2">
                            <div class="card dashboard-video-card overlapping-card">
                                <div class="dashboard-video-box imgvid-cover" (click)="plays()">
                                    <video [src]="detaildata.welcome_video" class="cus_file_overlay w-100" controls controls disablePictureInPicture controlsList="noplaybackrate nodownload" type="video/*" style="height:100% !important" id="myAudio1" (click)="plays()"></video>
                                </div>
                                <div class="card-content overlapping-card-content p-3" (click)="plays()">
                                    <h3 class="title m-0 white-color p-2"> <span [translate]="'GREATER.TOUR_WELCOME'"> </span> </h3>
                                </div>

                                <div class="play-btn-box" *ngIf="showButton">
                                    <a href="javascript:void();" (click)="plays()">
                                        <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_b_4165_2785)">
                                            <circle cx="41" cy="41" r="40" fill="white" fill-opacity="0.2"/>
                                            <circle cx="41" cy="41" r="40" stroke="white" stroke-width="2"/>
                                            </g>
                                            <mask id="mask0_4165_2785" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="17" y="18" width="47" height="47">
                                            <rect x="17" y="18" width="47" height="47" fill="#004FEC"/>
                                            </mask>
                                            <g mask="url(#mask0_4165_2785)">
                                            <path d="M28.3366 50.1804L28.3366 32.8176C28.3366 29.2616 32.201 27.03 35.2853 28.808L42.8147 33.1442L50.344 37.4985C53.4283 39.2765 53.4283 43.7215 50.344 45.4996L42.8147 49.8539L35.2853 54.19C32.201 55.9681 28.3366 53.7546 28.3366 50.1804Z" fill="white"/>
                                            </g>
                                            <defs>
                                            <filter id="filter0_b_4165_2785" x="-27.1828" y="-27.1828" width="136.366" height="136.366" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="13.5914"/>
                                            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4165_2785"/>
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_4165_2785" result="shape"/>
                                            </filter>
                                            </defs>
                                        </svg>

                                    </a>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 col-lg-5 pb-2">
                            <div class="card">
                                <div class="dashboard-chartbox-img transparent-bg border-radius20" *ngIf="!chartShow">
                                    <img src="../../../assets/images/financials.svg" />
                                </div>
                                <div class="dashboard-chartbox border-radius20 imgvid-contain" *ngIf="chartShow">
                                    <div class="section-heading pb-2">
                                        <h4 class="title m-0">Financials</h4>
                                    </div>
                                    <canvas baseChart class="chart" [data]="doughnutChartData" [type]="doughnutChartType" [options]="chartOptions" [plugins]="doughnutChartPlugins"></canvas>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section class="inner-section-wrap">
                    <div class="row d-flex justify-content-between align-items-center pb-3">
                        <!-- start Coulam -->
                        <div class="card dark-bg max-width-200 w-100 py-1 my-2 mx-sm-2" *ngFor="let item of detaildata.cards">
                            <a class="white-color" [routerLink]="item.link">
                                <div class="card-body">
                                    <div class="row align-items-center">
                                        <div class="col-12">
                                            <p class="mb-0 white-color font-12 font-w-normal">{{item.name}}</p>
                                        </div>
                                        <!-- <div class="col-5 text-end">
                                        <span class="white-color"> See All </span>
                                    </div> -->
                                    </div>
                                    <div class="d-flex py-3 align-items-center">
                                        <div class="fill-ic">
                                            <i [class]="item.class"></i>
                                        </div>
                                        <h2 class="ps-3 title white-color m-0 font-w-normal">{{item.counter}}</h2>
                                    </div>
                                    <!-- <div class="d-flex align-items-center">
                                    <p class="mb-0">Lorem ipsum is a simply dummy text in all industries.</p>
                                </div> -->
                                </div>
                            </a>
                        </div>
                        <!-- End Coulam -->
                    </div>
                    <!--end row-->
                </section>

                <section class="inner-section-wrap pt-2">
                    <div class="section-heading pb-2">
                        <h3 class="title">
                            <span [translate]="'GREATER.TRENDING_VIDEOS'"> </span>
                        </h3>
                    </div>
                    <div class="row d-flex justify-content-between align-items-center pb-3">
                        <!-- start Coulam -->
                        <div class="card dark-bg max-width-350 w-100 py-1 my-3 mx-sm-2 min-height-350 border-radius10" *ngIf="AlbumList.length ==0">
                            <div class="card-body blank-card-body text-center">
                                <h3 class="title m-0 pt-4 pb-3 px-sm-2 px-1">
                                    <span [translate]="'GREATER.BIG_JOURNEY_BEGIN_WITH_SMALL_CHANGES'"> </span>
                                </h3>
                                <div class="py-4">
                                    <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_b_455_2721)">
                                                <circle cx="41" cy="41" r="40" fill="white" fill-opacity="0.2"/>
                                                <circle cx="41" cy="41" r="40" stroke="white" stroke-width="2"/>
                                            </g>
                                            <mask id="mask0_455_2721" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="18" y="18" width="47" height="47">
                                                <rect x="18" y="18" width="47" height="47" fill="#004FEC"/>
                                            </mask>
                                            <g mask="url(#mask0_455_2721)">
                                                <path d="M29.3366 50.1804L29.3366 32.8176C29.3366 29.2616 33.201 27.03 36.2853 28.808L43.8147 33.1442L51.344 37.4985C54.4283 39.2765 54.4283 43.7215 51.344 45.4996L43.8147 49.8539L36.2853 54.19C33.201 55.9681 29.3366 53.7546 29.3366 50.1804Z" fill="white"/>
                                            </g>
                                            <defs>
                                                <filter id="filter0_b_455_2721" x="-27.1828" y="-27.1828" width="136.366" height="136.366" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="13.5914"/>
                                                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_455_2721"/>
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_455_2721" result="shape"/>
                                                </filter>
                                            </defs>
                                        </svg>
                                </div>
                                <div class="btn-box pt-3 pb-4">
                                    <a href="javascript:void(0);" class="btn custom-btn gradient1-btn" (click)="redirectCheck()"><span [translate]="'GREATER.CREATE_NOW'"> </span> </a>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->

                        <!-- start Coulam -->
                        <div class="card dark-bg max-width-350 w-100 py-1 my-3 mx-sm-2 overlapping-card border-radius10" *ngFor="let item of AlbumList">
                            <a routerLink="/video-detail" class="d-block">
                                <div class="card-video2-box imgvid-cover border-radius10">
                                    <img loading="lazy" class="border-radius10" [src]="item.thumbnail" />
                                </div>
                                <!-- <div class="card-edit-ic">
                                            <a href="javascript:void(0):"> <i class="fa-solid fa-pencil"></i> </a>
                                        </div> -->
                                <div class="card-content overlapping-card-content p-3">
                                    <!-- <div class="video-category pb-3">
                                        <div class="brand-badge p-3 border-radius10 d-inline-block"> {{loginDetail.name}} {{loginDetail.surname}}</div>
                                    </div> -->
                                    <h5 class="title m-0 white-color py-3"> {{item.name}}</h5>

                                    <div class="card-footer p-0 m-0 border-0">
                                        <div class="row align-items-center">
                                            <!-- <div class="col-5">
                                                            <div class="video-duration d-flex align-items-center">
                                                                <i class="fa-solid fa-clock greenlight-color font-16"></i>
                                                                <span class="ps-1 font-11"> 20 Min </span>
                                                            </div>
                                                        </div> -->
                                            <div class="col-12">
                                                <div class="d-flex align-items-center justify-content-start">
                                                    <div class="video-view d-flex align-items-center pe-3">
                                                        <i class="gricon gr_ic_eye brandsecundary-color font-16"></i>
                                                        <span class="ps-1 font-11 white-color"> {{item.view}} </span>
                                                    </div>
                                                    <div class="video-like d-flex align-items-center">
                                                        <i class="gricon gr_ic_heart orange-color font-16"></i>
                                                        <span class="ps-1 font-11 white-color"> {{item.like}} </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </a>

                        </div>
                        <!-- End Coulam -->

                        <!-- <div *ngIf="b_AlbumList.length !=0">  -->
                        <div class="card dark-bg max-width-350 w-100 py-1 my-3 mx-sm-2 min-height-350 border-radius10" *ngFor="let item of b_AlbumList">
                            <div class="card-body blank-card-body text-center">
                                <h3 class="title m-0 pt-4 pb-3 px-sm-2 px-1">
                                    <!-- <span [translate]="'GREATER.BIG_JOURNEY_BEGIN_WITH_SMALL_CHANGES'"> </span> -->
                                </h3>
                                <div class="py-4">
                                    <!-- <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_b_455_2721)">
                                                    <circle cx="41" cy="41" r="40" fill="white" fill-opacity="0.2"/>
                                                    <circle cx="41" cy="41" r="40" stroke="white" stroke-width="2"/>
                                                </g>
                                                <mask id="mask0_455_2721" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="18" y="18" width="47" height="47">
                                                    <rect x="18" y="18" width="47" height="47" fill="#004FEC"/>
                                                </mask>
                                                <g mask="url(#mask0_455_2721)">
                                                    <path d="M29.3366 50.1804L29.3366 32.8176C29.3366 29.2616 33.201 27.03 36.2853 28.808L43.8147 33.1442L51.344 37.4985C54.4283 39.2765 54.4283 43.7215 51.344 45.4996L43.8147 49.8539L36.2853 54.19C33.201 55.9681 29.3366 53.7546 29.3366 50.1804Z" fill="white"/>
                                                </g>
                                                <defs>
                                                    <filter id="filter0_b_455_2721" x="-27.1828" y="-27.1828" width="136.366" height="136.366" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="13.5914"/>
                                                            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_455_2721"/>
                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_455_2721" result="shape"/>
                                                    </filter>
                                                </defs>
                                            </svg> -->
                                </div>
                                <div class="btn-box pt-3 pb-4">
                                    <!-- <a href="javascript:void(0);" class="btn custom-btn gradient1-btn" >
                                            <span [translate]="'GREATER.CREATE_NOW'"> </span> 
                                        </a> -->
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->


                    </div>
                </section>

            </div>
        </div>
        <!--end page wrapper -->

    </div>
    <app-footer></app-footer>
</main>

